import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useHostAuth } from '../../providers/host-auth-context';

interface RequireRolesProps {
  roles: string[];
  match?: 'all' | 'any';
  children: ReactNode;
  unauthorizedPath?: string;
}

export function RequireRoles({
  roles,
  match = 'any',
  children,
  unauthorizedPath = '/unauthorized',
}: RequireRolesProps) {
  const { isAuthenticated, user } = useHostAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const userRoles = user?.roles ?? [];
  const hasAccess =
    match === 'any'
      ? roles.some((r) => userRoles.includes(r))
      : roles.every((r) => userRoles.includes(r));

  if (!hasAccess) {
    return <Navigate to={unauthorizedPath} replace />;
  }

  return <>{children}</>;
}
